import styled from 'styled-components';
import { Button } from '@gerdau/hefesto/Button';

export const Container = styled.div`
  width: 100%;
  margin: auto;
  padding-bottom: 1rem;
  background: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-bottom: 1.5rem;
  }
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  margin: 0 1.3rem;

  & > header {
    width: 66px;
    height: 32px;
    left: 24px;
    top: 0px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: ${({ theme }) => theme.colors.grayDark3};

    margin-top: 0.5rem;
    margin-bottom: 1rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      margin-bottom: unset;
    }
  }

  & > div.inputs-container {
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
      flex-direction: row;
    }

    & > div {
      display: flex;
      align-items: center;
      flex-direction: column;
      bottom: 0.8rem;

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
      }

      & > .hefesto-button--secondary {
        margin-top: 20px;
        width: 172px;
        height: 50px;
        justify-content: center;
      }
    }
  }
`;

export const CleanFiltersButton = styled(Button)`
  padding: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-self: flex-end;
  }
`;

export const FilterInputContainer = styled.div`
  margin-bottom: 0.5rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    &:first-child {
      margin-right: 1rem;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: 270px;
    margin-right: 1rem;
  }

  &
    > .select-container
    > .select-container__label-wrapper--input-wrapper
    > input.select__input {
    box-sizing: border-box;
    width: 270px;
    left: 0%;
    right: 0%;
    top: 2.4rem;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid #5d6569;
  }

  & > .select-container__label-wrapper--label {
    font-size: 1.4rem;
  }

  & > .ant-select {
    width: 100%;
  }
`;
